import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";

export const getMonitorsLength = (state: ReducerFromState<PlayerReducer>): number => state.player.monitors.length;
